export default __webpack_public_path__ + "static/popup-desktop-x2-17f1b58646c9041d6169a8111087e35d.jpg";